// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  approvedTo: t.union([DateSchema, t.null]),
  userProfileBreederRoleIds: t.array(PositiveIntegerSchema),
});

export const UpdateBreederBindingAdminSchema = excess(requiredPart);

export interface UpdateBreederBindingAdmin extends t.TypeOf<typeof UpdateBreederBindingAdminSchema> {}
